const ORDER_SUCCESS_NOTICE_KEY = 'chefmargaro_order_success';

export function saveOrderSuccessNotice(notice) {
  try {
    sessionStorage.setItem(ORDER_SUCCESS_NOTICE_KEY, JSON.stringify(notice));
  } catch {
    // ignore quota / private mode
  }
}

export function readOrderSuccessNotice() {
  try {
    const raw = sessionStorage.getItem(ORDER_SUCCESS_NOTICE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function clearOrderSuccessNotice() {
  try {
    sessionStorage.removeItem(ORDER_SUCCESS_NOTICE_KEY);
  } catch {
    // ignore
  }
}
